/* -------------------------------------------------------------------------- *
 * BgVideo                                                                     *
 * -------------------------------------------------------------------------- *
 * Lazy-loads background video sources after the page is idle, so the         *
 * video payload doesn't compete with LCP-critical resources. On mobile        *
 * (<768px) the video is skipped entirely — the poster image shows instead.   *
 */

const settings = {
    // Set to true to load the background video on mobile (<768px) as well.
    // Disabled by default — the video is 6+ MB and hurts mobile performance.
    showVideoOnMobile: false,
};

const BgVideo = {
    selector: '.js-bg-video',

    init() {
        const video = document.querySelector(this.selector);
        if (!video) return;

        if (!settings.showVideoOnMobile && window.matchMedia('(max-width: 767px)').matches) return;

        const load = () => {
            video.querySelectorAll('source[data-src]').forEach((source) => {
                source.src = source.dataset.src;
            });
            video.load();
            video.play().catch(() => {});
        };

        if ('requestIdleCallback' in window) {
            requestIdleCallback(load, { timeout: 2000 });
        } else {
            window.addEventListener('load', load);
        }
    },
};

export default BgVideo;
